import { ResponsiveImage } from '~/graphql/fragments'
import { graphql } from '~/lib/datocms/graphql'

export const queryArticles = graphql(
  /* GraphQL */ `
    query Articles(
      $first: IntType = 100
      $skip: IntType
      $allInCategory: [ItemId]
      $slug: String
      $notInSlug: [String]
      $orderBy: [ArticleModelOrderBy] = _firstPublishedAt_DESC
    ) {
      _allArticlesMeta(
        filter: { category: { allIn: $allInCategory }, slug: { eq: $slug, notIn: $notInSlug } }
      ) {
        count
      }
      allArticles(
        first: $first
        skip: $skip
        filter: { category: { allIn: $allInCategory }, slug: { eq: $slug, notIn: $notInSlug } }
        orderBy: $orderBy
      ) {
        __typename
        _modelApiKey
        id
        createdAt
        category {
          _modelApiKey
          __typename
          id
          name
          slug
        }
        excerpt
        image {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 448 }
          ) {
            ...ResponsiveImage
          }
        }
        title
        slug
      }
    }
  `,
  [ResponsiveImage]
)
